var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlaces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#87BB4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2375 12.5C33.4625 12.5 35.775 13.8625 36.825 16.3C36.9375 16.525 36.875 16.8 36.6875 16.9875L16.9875 36.6875C16.8125 36.8625 16.5375 36.925 16.3 36.825C13.8625 35.775 12.5 33.4625 12.5 30.2375V19.7625C12.5 15.75 15.75 12.5 19.7625 12.5H30.2375ZM21.4 26C22.0375 26 22.675 25.775 23.1625 25.3C24.425 24.1 25.825 22.1875 25.3 19.925C24.825 17.85 23 16.925 21.4 16.925C19.8 16.925 17.975 17.85 17.5 19.9125C16.9625 22.1875 18.3625 24.1 19.6375 25.3C20.125 25.7625 20.7625 26 21.4 26ZM20.1875 20.6125C20.1875 19.925 20.7375 19.3625 21.4375 19.3625C22.125 19.3625 22.6875 19.925 22.6875 20.6125C22.6875 21.3 22.125 21.8625 21.4375 21.8625C20.75 21.8625 20.1875 21.3 20.1875 20.6125ZM34.3377 35.6625C34.6127 35.9375 34.5752 36.3875 34.2377 36.575C33.1377 37.1875 31.8002 37.5 30.2377 37.5H19.7627C19.4002 37.5 19.2502 37.075 19.5002 36.825L27.0502 29.275C27.3002 29.025 27.6877 29.025 27.9377 29.275L34.3377 35.6625ZM37.5 30.2375V19.7625C37.5 19.4 37.075 19.25 36.8125 19.5L29.2625 27.05C29.0125 27.3 29.0125 27.6875 29.2625 27.9375L35.6625 34.3375C35.9375 34.6 36.3875 34.575 36.575 34.2375C37.1875 33.15 37.5 31.8 37.5 30.2375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaces);
export default __webpack_public_path__ + "static/media/icon_places.c85e96b5b3373beee5ebd41e986b20ae.svg";
export { ForwardRef as ReactComponent };